export const getLogoByTheme = (
  isDarkMode = document.documentElement.classList.contains('dark')
) =>
  ['/assets/eqiplus-logo.png', '/assets/eqiplus-logo-white.png'][
    Number(isDarkMode)
  ];
